import RichText from 'src/components/richtext/Richtext';
import IQuote from 'src/lib/types/Quote';
import styles from './Quote.module.css';

/**
 * Markup har blitt lånt herfra:
 * https://css-tricks.com/quoting-in-html-quotations-citations-and-blockquotes/
 **/

//#region [Props]
type QuoteProps = {
    value: IQuote;
};
//#endregion

//#region [Component]
export default function Quote({ value }: QuoteProps) {
    return <figure className={styles.SQuoteContainer}>
        <blockquote className={styles.SQuoteText}>
            <RichText disableCustomComponents value={value.quoteText} />
        </blockquote>
        {value.sourceV2 && <figcaption className={styles.SQuoteSource}>- {value.sourceV2}</figcaption>}
    </figure>;
}
//#endregion